// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_SERVICES = "GET_SERVICES";
export const CREATE_SERVICES = "CREATE_SERVICES";
export const UPDATE_SERVICES = "UPDATE_SERVICES";
export const DELETE_SERVICES = "DELETE_SERVICES";
